import React, { useState, useRef } from 'react';
import { colors } from 'globalStyle';
import { Title } from 'components/Texts';
import { ArrowLeft, ArrowRight } from 'icons';
import { Carousel } from 'components/Carousel';
import ArrowIcon from 'assets/icons/arrow_dropdown_primary.svg';
import {
  Accordion, AccordionDetails, AccordionSummary, Box, Grid, styled,
} from '@material-ui/core';

import ProjectTextContent from './ProjectTextContent';
import ProjectSDG from './ProjectSDG';

const SECTIONS = Object.freeze([
  {
    id: 'who',
    name: '¿Quiénes somos?',
    componentWidth: '91.31%',
    Component: ({ whoIAm, ...props }) => <ProjectTextContent text={whoIAm} {...props} />,
    paddingMobile: '8px 16px 16px 3px',
  },
  {
    id: 'what',
    name: '¿Qué hacemos?',
    componentWidth: '91.31%',
    Component: ({ whatDoWeDo, ...props }) => <ProjectTextContent text={whatDoWeDo} {...props} />,
    paddingMobile: '8px 16px 16px 3px',
  },
  {
    id: 'why',
    name: '¿Por qué lo hacemos?',
    componentWidth: '91.31%',
    Component: ({ whyDoWeDo, ...props }) => <ProjectTextContent text={whyDoWeDo} {...props} />,
    paddingMobile: '8px 16px 16px 3px',
  },
  {
    id: 'SDG',
    reducedName: 'ODS',
    name: 'Objetivos de desarrollo sostenible',
    componentWidth: '91.31%',
    Component: ProjectSDG,
    paddingMobile: '8px 16px 16px 3px',
  },
]);

const carouselSettings = Object.freeze({
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  autoplay: false,
  slidesToScroll: 1,
  adaptiveHeight: false,
  style: {
    width: '80%',
  },
});

const arrowProps = Object.freeze({
  width: '13px',
  isClick: true,
  height: '28px',
  color: colors.primary,
});

export default function ProjectMeetCompany({
  isDesktop, images, initialActiveItems = { description: SECTIONS[0] }, companyName, ...props
}) {
  const carouselRef = useRef();
  const next = () => carouselRef.current?.slickNext();
  const prev = () => carouselRef.current?.slickPrev();
  const [activeItems, setActiveItems] = useState(isDesktop ? initialActiveItems : {});
  if (isDesktop) {
    return (
      <Grid container alignItems="center" direction="column" style={{ position: 'relative' }}>
        <Title size={30} color={colors.WHITE} mt={60} mb={30} isCenter>
          {`Conoce ${companyName}`}
        </Title>
        <Box
          zIndex={-1}
          width="100%"
          height="70%"
          position="absolute"
        >
          <StyledImageBox
            alt=""
            component="img"
            src={images && images[0]}
          />
          {isDesktop && <StyledImageBoxShadow />}
        </Box>
        <MeetCompanyCard container alignItems="center" justify="space-around">
          <ArrowLeft onClick={prev} {...arrowProps} />
          <Carousel refCarousel={carouselRef} {...carouselSettings} isCustomArrow>
            {SECTIONS.map((section) => (
              <div>
                <Grid
                  container
                  key={section.name}
                  style={{
                    overflow: 'auto',
                    maxHeight: '270px',
                  }}
                >
                  <section.Component isDesktop={isDesktop} contentName={section.name} {...props} />
                </Grid>
              </div>
            ))}
          </Carousel>
          <ArrowRight onClick={next} {...arrowProps} />
        </MeetCompanyCard>
      </Grid>
    );
  }
  return (
    <Grid container direction="column">
      {SECTIONS.map((section) => (
        <>
          <div
            style={{ visibility: 'hidden' }}
          />
          <StyledAccordion
            key={section.id}
            expanded={!!activeItems[section.id]}
            onChange={(_, isExpanded) => {
              setActiveItems(isExpanded ? { [section.id]: section } : {});
            }}
          >
            <StyledAccordionSummary expandIcon={(
              <Box
                component="img"
                src={ArrowIcon}
                alt="expandir u ocultar información"
              />
              )}
            >
              <Title color={colors.primary}>
                {(!activeItems[section.id] && section.reducedName) || section.name}
              </Title>
            </StyledAccordionSummary>
            <StyledAccordionDetails {...section}>
              <section.Component {...props} />
            </StyledAccordionDetails>
          </StyledAccordion>
        </>
      ))}
    </Grid>
  );
}

const StyledAccordion = styled(Accordion)({
  maxWidth: '100%',
  boxShadow: 'none',
  marginBottom: '20px',
  backgroundColor: colors.background.GRAY_3,
  '&::before': {
    backgroundColor: 'transparent',
  },
});

const StyledAccordionSummary = styled(AccordionSummary)({
  minHeight: '45px !important',
  maxHeight: '45px !important',
  backgroundColor: colors.WHITE,
  borderRadius: '10px !important',
  boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.08)',
});

const StyledAccordionDetails = styled(AccordionDetails)((props) => ({
  width: '100%',
  flexDirection: 'column',
  padding: props.paddingMobile,
}));

const MeetCompanyCard = styled(Grid)({
  width: '84.69%',
  padding: '65px 40px',
  borderRadius: '30px',
  background: colors.WHITE,
  boxShadow: '0px 4px 30px 0px rgba(0, 0, 0, 0.08)',
});

const StyledImageBox = styled(Box)({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'relative',
});

const StyledImageBoxShadow = styled(Box)({
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  content: '""',
  position: 'absolute',
  background: 'linear-gradient(180deg, rgba(65, 183, 191, 0.50) -105.53%, rgba(65, 183, 191, 0.01) 193.66%)',
});
